import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import DataGridV2 from "../../components/DataGridV2";
import { apps, LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { useSelector } from "react-redux";
import { useState } from "react";
import { INITIAL_ROW_SELECTION_MODEL } from "../../components/DataGridV2/constants";
import { getLocalStorageItem, setLocalStorageItem } from "../../_helpers";
import { getStandardOptionColumns } from "./utils";


export default function StandardOptionsGrid(props) {
  const { options, onSelect } = props;
  const { t, i18n } = useTranslation();
  const apiRef = useGridApiRef();
  const app = useSelector((state) => state.app);
  const keyPrefix = app === apps.huisinfo ? "BUYERS_GUIDE" : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_PAGINATION[keyPrefix], undefined
  ))
  
 const rows = options.map((row, index) => ({
    id: row.optionStandardId || index,
    ...row,
  }));

 const columns = getStandardOptionColumns({ t, keyPrefix, i18n, apiRef })
  
  const getStandardOptionsPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
    const userSelectedRows = isAllSelected ? options : idsToExport.map(id => options?.find(item => item?.optionStandardId === id));
    return userSelectedRows;
  };

  const onPaginationModelChange = useCallback((newPaginationModel) => {
    setPaginationModel(newPaginationModel)
    setLocalStorageItem(
      LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_PAGINATION[keyPrefix],
      newPaginationModel
    );
  }, [keyPrefix])

  return (
   <DataGridV2
          localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_SEARCH_TEXT[keyPrefix]}
          localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_FILTER[keyPrefix]}
          localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_SORT[keyPrefix]}
          localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_ORDER[keyPrefix]}
          localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_WIDTH[keyPrefix]}
          localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.STANDARD_OPTIONS_COLUMN_VISIBILITY[keyPrefix]}
          apiRef={apiRef}
          checkboxSelection
          rows={rows}
          columns={columns}
          pagination
          filterMode="client"
          {...(!!paginationModel && { paginationModel })}
          onPaginationModelChange={onPaginationModelChange}
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
          onRowClick={(params) => {
            if (onSelect) {
              onSelect(params.row);
            }}}
             toolbarProps={{
            selectedRows: rowSelectionModel,
            getData: getStandardOptionsPrintAndDownload
          }}
     />
  );
}
